import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import {
    FirstTaskRewardService,
    type FirstTaskRewardService as FirstTaskRewardServiceType,
} from '../../first-task-reward/first-task-reward-service';
import type { FtoProReportOnboardingService } from '../fto-pro-report-onboarding-service';

/** 将 FTO 可阅读报告事件转交给统一首次任务奖励服务。 */
@injectable()
export class FtoProReportOnboardingServiceImpl implements FtoProReportOnboardingService {
    private _isInitialized = false;

    constructor(
        @inject(FirstTaskRewardService)
        private readonly _rewardService: FirstTaskRewardServiceType,
    ) {}

    async initialize(): Promise<void> {
        this._isInitialized = true;
    }

    notifyReportAvailable(reportId: string): void {
        if (!this._isInitialized || !reportId) return;
        this._start(reportId);
    }

    debugStart(reportId: string): void {
        if (!import.meta.env.DEV || !reportId) return;
        this._isInitialized = true;
        this._start(reportId);
    }

    destroy(): void {
        this._isInitialized = false;
        this._rewardService.destroyReport();
    }

    private _start(reportId: string): void {
        this._rewardService.startReport({
            taskId: reportId,
            agentType: 'FTO_SEARCH',
            reportSelector: '[data-testid="fto-pro-report-content"]',
            shareSelector: '[data-testid="fto-pro-report-share"]',
            exportSelector: '[data-testid="fto-pro-report-export"]',
        });
    }
}
